import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import ColorPickerEditor from 'common/components/ColorPicker';
import FontPickerEditor from 'common/components/FontPicker';

import {
    setFormInputHelperTextFont,
    setFormInputHelperTextFontSize,
    setFormInputHelperTextColor,
} from 'common/entities/form/styleConfiguration/actions';
import {
    DEFAULT_FONT,
    DEFAULT_FONT_SIZE,
    DEFAULT_INPUT_HELPER_TEXT_COLOR,
} from 'common/entities/form/styleConfiguration/defaultValues';
import { getDefaultStyle, styleShapePropTypes } from 'common/entities/form/styleConfiguration/utils';
import { getFormInputHelperTextStyles } from 'common/entities/form/styleConfiguration/selectors';
import { getColors } from 'common/entities/color/selectors';
import { getFonts } from 'common/entities/font/selectors';

import { getFormId } from '../../../../selectors';

import { FORM_FIELDS_QA } from '../../../../utils/qaIdConstants';

const HelperTextPanel = ({ formId, font, fontSize, color, colorList, fontList, ...props }) => (
    <React.Fragment>
        <FontPickerEditor
            fontFamilyList={fontList}
            defaultFontFamily={font}
            onChangeFontFamily={(id) => props.setFormInputHelperTextFont(formId, id)}
            defaultFontSize={fontSize}
            onChangeFontSize={(size) => props.setFormInputHelperTextFontSize(formId, size)}
            fontFamilyQa={`${FORM_FIELDS_QA}--fontFamily`}
            fontSizeQa={`${FORM_FIELDS_QA}--fontSize`}
        />
        <ColorPickerEditor
            colorList={colorList}
            firstColor={color}
            changeFirstColor={(id) => props.setFormInputHelperTextColor(formId, id)}
            qaId={FORM_FIELDS_QA}
        />
    </React.Fragment>
);

HelperTextPanel.propTypes = {
    color: styleShapePropTypes,
    font: styleShapePropTypes,
    fontSize: PropTypes.number,
    formId: PropTypes.string.isRequired,
    colorList: PropTypes.arrayOf(PropTypes.object).isRequired,
    fontList: PropTypes.arrayOf(PropTypes.object).isRequired,
    setFormInputHelperTextFont: PropTypes.func.isRequired,
    setFormInputHelperTextFontSize: PropTypes.func.isRequired,
    setFormInputHelperTextColor: PropTypes.func.isRequired,
};

HelperTextPanel.defaultProps = {
    color: getDefaultStyle(DEFAULT_INPUT_HELPER_TEXT_COLOR),
    font: getDefaultStyle(DEFAULT_FONT),
    fontSize: DEFAULT_FONT_SIZE,
};

const mapStateToProps = (state) => {
    const formId = getFormId(state);
    const colorList = getColors(state);
    const fontList = getFonts(state);
    const { color, font, fontSize } = getFormInputHelperTextStyles(state, formId);

    return {
        formId,
        color,
        font,
        fontSize,
        colorList,
        fontList,
    };
};

const mapDispatchToProps = {
    setFormInputHelperTextFont,
    setFormInputHelperTextFontSize,
    setFormInputHelperTextColor,
};

export default connect(mapStateToProps, mapDispatchToProps)(HelperTextPanel);
